export default {
  'valid-pin': 'Você já possui um pin válido, verifique seu email',

  'email-pin': 'Verifique seu email para obter o pin',
  'email-sent': 'Verifique seu email para recuperar sua senha',
  'lease-sent': 'Verifique seu email para liberar o acesso',
  'session-allowed': 'Sessão autorizada',
  // eslint-disable-next-line max-len
  'pass-recovered': 'Senha alterada com sucesso! Você já pode realizar o login nos sistemas Angellira utilizando a nova senha!'
};
